<template>
  <div
    class="bg-white flex flex-col items-start gap-4 shadow-combined-elevation-1 p-4 md:p-6 rounded-3xl w-full"
    :data-testid="dataTestid"
  >
    <slot name="icon">
      <V2IconsShieldCheck
        class="wh-8 md:wh-16"
        aria-hidden="true"
      />
    </slot>

    <h2 class="text-semantic-sizing-headline-sm font-semibold text-semantic-surface-on-surface">
      <slot name="title">
        Independent. Human. Reviewed before publish.
      </slot>
    </h2>

    <div class="text-semantic-sizing-body-sm text-semantic-surface-on-surface mb-2">
      <slot name="content">
        Every guide on Compare Club is researched, written, and edited by people, and reviewed by our editorial team before it goes live. Our guides are general information — not personal financial, tax, or medical advice.
      </slot>
    </div>

    <V2AtomsButton
      theme="primary"
      has-icon-right
      :to="policyUrl"
      data-testid="editorial-trust-card-policy-btn"
      class="mb-2"
    >
      Read our editorial policy
    </V2AtomsButton>

    <div
      class="w-full border-t border-semantic-outline-variant pt-6 text-semantic-sizing-label text-semantic-surface-on-surface-variant"
    >
      Compare Club Australia Pty Ltd is an Authorised Representative (001279036) of Alternative Media Pty Ltd (AFSL/ACL 486326), and a signatory to the PHIIA Code of Conduct.
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'V2MoleculesEditorialTrustCard'
})

defineProps({
  dataTestid: {
    type: String,
    default: 'editorial-trust-card'
  },

  policyUrl: {
    type: String,
    default: '/editorial-policy/'
  }
})
</script>
